import React, { useRef } from "react";
import style from "./donation.module.css";
import { Col, Row } from "react-bootstrap";
import Adminpayment from "./adminpayment";
import Faith from "./faith";

export default function Donate() {
  const donationSectionRef = useRef(null);
  const handleScrollToDonation = () => {
    donationSectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className={style.donatemaincontainer}>
        <div className="container">
          <div className={style.innerdonatecontainer}>
            <h1 className={style.h1main}>
              From every tribe and tongue, life is sacred.
            </h1>
            <h1 className={style.h1main}> — Revelation 7:9</h1>
            <div className={style.textBoxx}>
              <h1 className={style.maintextheader}> GIVE LIFE. </h1>
              <h1 className={style.maintextheader}> CHANGE THE WORLD.</h1>
            </div>
            <p className={style.yellowText}>
              Your faith can reach where your feet can’t.
            </p>
            <p className={style.Together}>
              Together, we’re fueling life-affirming missions in 25 nations.
            </p>
            <div className={style.buttonFirst}>
              <p
                className={style.globalBtn}
                onClick={handleScrollToDonation}
                style={{ cursor: "pointer" }}
              >
                Give to the Global Life Fund
              </p>
            </div>
            <p className={style.One}>One gift. Countless lives touched.</p>
          </div>
        </div>
      </div>
      <div className={style.gobalcontainer}>
        <div className={style.rowOuterddiv}>
          <div className="container">
            <h1 className={style.global}>OUR GLOBAL MISSION</h1>
            <h1 className={style.empoweringh1}> Empowering Life-Affirming</h1>
            <h1 className={style.empoweringh1}>Ministries Worldwide</h1>
          </div>
        </div>
        <div className="container">
          <Row>
            <Col lg={{ span: 6, order: 1 }} md={{ order: 2 }}>
              <p className={style.parafundlife}>
                At FundLife, we believe every life is precious and every nation
                deserves hope. Our mission is simple yet profound — to
                strengthen and sustain local, Christ-centered organizations that
                are making a difference in the lives of women, men, and families
                facing unplanned pregnancies.
              </p>
              <p className={style.parafundlife1}>
                Across more than 25 countries, we come alongside pregnancy help
                centers, maternity homes, and adoption agencies — many of them
                small, under- resourced ministries doing life-changing work in
                their communities.
              </p>
              <p className={style.parafundlife}>
                These frontline heroes provide tangible help, compassionate
                care, and the life-giving message of God’s love to mothers and
                fathers in their moments of greatest need.
              </p>
            </Col>
            <Col
              lg={{ span: 6, order: 2 }}
              md={{ order: 1 }}
              className="d-flex justify-content-center align-items-center"
            >
              <img className={style.paraimg} src="/funddd.png" />
            </Col>
          </Row>
        </div>
      </div>
      {/* <Adminpayment /> */}
      <div ref={donationSectionRef}>
        <Adminpayment />
      </div>
      <div className={style.giftContainer}>
        <div className="container">
          <h1 className={style.h1Gift}>Your Gift Changes Lives</h1>
          <div className={style.giftBoxRow}>
            <Row>
              <Col md={3} className="d-flex justify-content-center">
                <img src="/giftbox1.png" className={style.giftimg}></img>
              </Col>
              <Col md={3} className="d-flex justify-content-center">
                <img src="/giftbox2.png" className={style.giftimg}></img>
              </Col>
              <Col md={3} className="d-flex justify-content-center">
                <img src="/giftbox3.png" className={style.giftimg}></img>
              </Col>
              <Col md={3} className="d-flex justify-content-center">
                <img src="/giftbox4.png" className={style.giftimg}></img>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      {/* <Faith/> */}
      <Faith onScrollToDonation={handleScrollToDonation} />
    </>
  );
}
